export default {
  main: "#5028CC",
  secondary: "#FE6600",
  background: "#082841",
  button: "#D83180",
  buttonSecondary: "#2853fd",
  iconSecundary: "#00a0ba",
  text: "#352F80",
};
